// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.gm-style-iw-c {\n  padding: 0 !important;\n  transform: translate(-50%, 70%) !important;\n}\n.gm-style-iw-t::after {\n  transform: translate(-50%, 395%) rotate(135deg) !important;\n}\n.gm-style-iw-d + button {\n  display: none !important;\n}\n.gm-style-iw-d {\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: auto !important;\n}\n", ""]);
// Exports
module.exports = exports;
